import { Injectable, inject } from "@angular/core";
import { Option } from "../classes/flow/Questionnaire/Option";
import { Question } from "../classes/flow/Questionnaire/Question";
import { Entity } from "../classes/flow/base/Entity";
import { EpfService } from "./epf.service";

@Injectable({
  providedIn: "root",
})
export class QuestionService {
  private epf = inject(EpfService);

  public async addQuestionOption(option: Option): Promise<Option> {
    return this.epf.addQuestionOption(option);
  }

  public async updateQuestionOption(option: Option): Promise<Option> {
    console.log(option);
    return this.epf.updateQuestionOption(option);
  }

  public async deleteQuestionOption(option: Option) {
    return this.epf.deleteQuestionOption(option);
  }

  public async addQuestion(question: Question, questionnaireId: number): Promise<Entity> {
    const result = this.epf.addQuestion(questionnaireId, question);
    return result;
  }

  public async updateQuestion(question: Question, questionnaireId: number): Promise<Entity> {
    const result = await this.epf.updateQuestion(questionnaireId, question);
    return result;
  }

  public async deleteQuestion(q: Question) {
    return this.epf.deleteQuestion(q);
  }
}
